import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { DatePipe } from '@angular/common';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';

import moment from 'moment';
import { catchError, map, Observable, Subscription } from 'rxjs';
import downloadjs from 'downloadjs';
import { HttpGuardService } from 'src/app/guards/http-guard.service';
import { leftMainMenu } from 'src/app/constants/leftMainMenuList';
import { leftSubMenu } from 'src/app/constants/leftSubMenuList';
import { ApiConstants } from '../constants/api-constants';
import { ToastrService } from 'ngx-toastr';
import {
  DeviceStatisticsPayloadModel,
  EntityIconListPayloadModel,
  EntityListPayloadModel,
  FilterInputDataPayloadModel,
  HistoryModel,
  ModuleHealthPayloadModel,
  PeripheralMetricsModel,
  ResponseModel,
  ThresholdEditPayloadModel,
  EntityAlertsCountPayloadModel,
  EntityTrackPayloadModel,
  ZoneDetailPayloadModel,
  ZoneOrderPayloadModel,
  ZonePlanEntityPayloadModel,
  ZonePlanEntityLocationPayloadModel,
  ZonePlanEntityLocationDeletePayloadModel,
  EntityOnboardPayloadModel,
  EntityOnboardDataPayloadModel,
  ZonePlanAggregationPayloadModel,
  ZonePlanTrackerEntityCountPayloadModel,
  UnknownModel,
} from 'src/app/model';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})
export class ServicecallService {
  masterConfigurationList: string = '';
  masterRbacList: string[] = [];
  allSites: any;
  masterLeafletData: any[] = [];
  caseFilters: { searchKey: string; caseFilter: any[] };
  rangeSelected: string;
  selectedEntitiesFromCHart: string[];
  filtersApplied: any = {}; //To retain filters across modules
  searchKeys: any = {}; //To retain search fields across modules
  isActiveAlertDtc : {isActiveAlerts: boolean, isActiveDTCCases: boolean} = {isActiveAlerts : false, isActiveDTCCases : false}
  entitiesDateApplied : any = {};
  dateState : any = [];

  private _subscription: Subscription;
  private _sessionTimeoutFlag: boolean = false;

  constructor(
    private http: HttpClient,
    private router: Router,
    private httpGuard: HttpGuardService,
    private toastr: ToastrService,
    public jwtHelper: JwtHelperService,
    private datePipe: DatePipe,
    private _dataService: DataService
  ) {
    this._subscription = this._dataService.events.subscribe((res: any) => {
      if (res.name === 'sessionTimeout') {
        this._sessionTimeoutFlag = true;
      }
    });
  }

  /* Get siteId */
  getSiteId() {
    return sessionStorage.getItem('siteId')
      ? JSON.parse(sessionStorage.getItem('siteId') || '{}')
      : null;
  }

  setSiteLsit(list) {
    this.allSites = list?.length ? list : [];
  }

  getallSites() {
    const siteName = this.allSites.map((element) => {
      return element.name;
    });
    return siteName;
  }

  /* Tenant List */
  getTenantDetails() {
    return this.httpGuard.httpReq(
      'get',
      'API_ENDPOINT',
      ApiConstants.URL.tenantList
    );
  }

  /* Dropdown Configurations */
  configurationsInfo(attributes: any, isLoaderNeeded: boolean = true) {
    const postData = { attributes: attributes, siteId: this.getSiteId() };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.configurationsInfo,
      postData,
      isLoaderNeeded
    );
  }

  /* User registration service */
  registerUser(userDetails: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.signup,
      userDetails
    );
  }

  Login(domain: string, username: string, password: string) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.login,
      { domain: domain, username: username, identifier: password }
    );
  }

  enquiry(set: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.enquiry,
      { set }
    );
  }

  /* Upload Image */
  updateImage(relativePath: any, type: any, fileData: any, recordId: any) {
    const formData: FormData = new FormData();
    if (fileData) {
      formData.append('avatar', fileData, fileData.name);
    }
    if (relativePath) {
      formData.append('relativePath', relativePath);
    }
    if (type) {
      formData.append('type', type);
    }
    if (recordId) {
      formData.append('recordId', recordId);
    }
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.updateImage,
      formData
    );
  }

  /* Delete Image */
  deleteImage(recordId: any, relativePath: any, type: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.deleteImage,
      { recordId, relativePath, type }
    );
  }

  /* Settings Configurations */
  currentConfigurations(postData?: any) {
    let siteId = sessionStorage.getItem('plantProfileSiteId')
      ? JSON.parse(sessionStorage.getItem('plantProfileSiteId') || '{}')
      : null;
    postData.siteId =
      postData.tab === 'site' ? (siteId ? siteId : this.getSiteId()) : null;
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.configurations,
      postData
    );
  }

  /* Reset Password */
  resetPassword(payload : {userName?: string, email?: string, empId?: string, phone?: any}) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.resetPassword,
      payload
    );
  }

  /* List Users */
  listUser(
    tabType: any,
    page: any,
    roleId?: any,
    tradeId?: any,
    searchKey?: any,
    isActiveFilter?: any
  ) {
    const postData = {
      tabType,
      tradeId: tradeId,
      roleId: roleId,
      searchKey: searchKey,
      siteId: this.getSiteId(),
      status: isActiveFilter,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      `${ApiConstants.URL.usersList}/${page}`,
      postData
    );
  }

  /* Add/Edit Configurations */
  saveConfig(postData: any) {
    let url = postData.configurationId
      ? ApiConstants.URL.updateConfiguration
      : ApiConstants.URL.addConfiguration;
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', url, postData);
  }

  /* Delete Configurations */
  deleteConfiguration(postData: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.deleteConfiguration,
      postData
    );
  }

  /* create Users */
  createUser(userDetails: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.createUser,
      { userDetails }
    );
  }

  /* Attribute List */
  attributeList(postData?: any) {
    postData.siteId = postData.siteId ? postData.siteId : this.getSiteId();
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.attribute,
      postData
    );
  }

  /* delete Users */
  deleteUser(empId: any, userId: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.deleteUser,
      { empId, userId }
    );
  }

  /* edit Users */
  editUser(userDetails: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.editUser,
      userDetails
    );
  }

  /* check user name availability */
  availableUsername(username: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.availableUsername,
      { username }
    );
  }

  /* change password */
  changePassword(
    userName: any,
    oldPassword: any,
    newPassword: any,
    sourceTime: any
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.changePassword,
      { userName, oldPassword, newPassword, sourceTime }
    );
  }

  /* Get role types */
  roleTypes() {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.roleType,
      {}
    );
  }

  /* Get available role */
  availableRoles() {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.availableRoles,
      {}
    );
  }

  /* Get roles */
  listRoles(postData?: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.rolesList,
      postData
    );
  }

  /* Get add/edit role */
  saveRole(set: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.saveRole,
      set
    );
  }

  /* logout */
  logout(userName: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.logout,
      { userName }
    );
  }

  /* Delete Role */
  deleteRole(postData: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.deleteRole,
      postData
    );
  }

  /* Get trades */
  listTrades(postData?: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.tradeList,
      postData
    );
  }

  /* Get add/edit trade */
  saveTrade(set: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.saveTrade,
      set
    );
  }

  /* Get available trades */
  availableTrades() {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.availableTrades,
      {}
    );
  }

  /* Delete Role */
  deleteTrade(postData: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.deleteTrade,
      postData
    );
  }

  /* Error codes */
  errorCodes() {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.errorCodes,
      {}
    );
  }

  /* Get add/edit Error Code */
  saveErrorCode(set: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.saveErrorCode,
      set
    );
  }

  /* Delete Error Code */
  deleteErrorCode(postData: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.deleteErrorCode,
      postData
    );
  }

  /* Save role type */
  saveRoleType(set: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.saveRoleType,
      set
    );
  }

  /* Archive data */
  retrieveArchivalDetails(indexType: any, scope: any, siteId?: any) {
    const postData = { indexType, scope, siteId: this.getSiteId() };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.retrieveArchivalDetails,
      postData
    );
  }

  /* Feature List */
  getFeatureList() {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getFeatureList,
      {}
    );
  }

  /* Feature Action */
  saveFeature(featureDetails: any, action: any, featureActionId?: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.saveFeature,
      { featureDetails, action: action, featureActionId: featureActionId }
    );
  }

  /* Feature Action */
  deleteFeature(featureId: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.deleteFeature,
      { featureId: featureId }
    );
  }

  /* User group list */
  userGroupList(index: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.userGroupList,
      { index }
    );
  }

  /* User group action */
  userGroupAction(userGroupDetails: any, action: any, userGroupId?: any) {
    if (action === 'delete') {
      return this.httpGuard.httpReq(
        'post',
        'API_ENDPOINT',
        ApiConstants.URL.userGroupAction,
        { action: action, userGroupId: userGroupId }
      );
    } else {
      return this.httpGuard.httpReq(
        'post',
        'API_ENDPOINT',
        ApiConstants.URL.userGroupAction,
        { userGroupDetails, action: action, userGroupId: userGroupId }
      );
    }
  }

  /* Mongo DB Snapshots */
  mongoDBSnapshots() {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.mongoDBSnapshots,
      {}
    );
  }

  /* SyncInfo Details */
  syncInfoDetails() {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.syncInfoDetails,
      {}
    );
  }

  /* Update Trade Image */
  updateTradeImage(
    fileData: any,
    type: any,
    imageId: any,
    scope: any,
    tradeName: any,
    tradeId: any
  ) {
    const formData: FormData = new FormData();
    if (fileData) {
      formData.append('avatar', fileData, fileData.name);
    }
    if (type) {
      formData.append('type', type);
    }
    if (imageId) {
      formData.append('imageId', imageId);
    }
    if (scope) {
      formData.append('scope', scope);
    }
    if (tradeName) {
      formData.append('tradeName', tradeName);
    }
    if (tradeId) {
      formData.append('tradeId', tradeId);
    }
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.updateTradeImage,
      formData
    );
  }

  /* Get Ota App List */
  getOtaApp() {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getOtaAppList,
      {}
    );
  }

  /* save Ota */
  saveOtaApp(action: any, otaAppDetails: any, otaAppActionId?: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.saveOtaApp,
      {
        action: action,
        otaAppDetails: otaAppDetails,
        otaAppActionId: otaAppActionId,
      }
    );
  }

  /* Delete Ota */
  deleteOtaApp(otaAppId?: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.deleteOtaApp,
      { otaAppId: otaAppId }
    );
  }

  /* Upload Ota File */
  uploadOtaFile(relativePath: any, fileData: any, recordId: any) {
    const formData: FormData = new FormData();
    const type: any = 3;
    if (fileData) {
      formData.append('avatar', fileData, fileData.name);
    }
    if (relativePath) {
      formData.append('relativePath', relativePath);
      formData.append('type', type);
    }

    if (recordId) {
      formData.append('recordId', recordId);
    }
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.uploadOtaFile,
      formData
    );
  }
  currentAlertRules(_postData: any) {
    let siteId = sessionStorage.getItem('plantProfileSiteId')
      ? JSON.parse(sessionStorage.getItem('plantProfileSiteId') || '{}')
      : null;
    _postData.siteId =
      _postData.tab === 'site' ? (siteId ? siteId : this.getSiteId()) : null;
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.currentAlertRules,
      _postData
    );
  }
  getProfileDetails(id: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.userDetails,
      id
    );
  }

  /* Get role list */
  roleList() {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.roleList,
      {}
    );
  }

  /* Get trade list */
  tradeList() {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.tradesList,
      {}
    );
  }

  insertAlertRule(_postData: any, type?: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.insertAlertRule,
      _postData
    );
  }

  updateAlertRule(_postData: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.updateAlertRule,
      _postData
    );
  }

  deleteAlertRule(_postData: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.deleteAlertRule,
      _postData
    );
  }

  inserAlertProfile(payload: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.createAlertProfile,
      payload
    );
  }

  alertIdList(_postData: any) {
    _postData.siteId = _postData.siteId ? _postData.siteId : this.getSiteId();
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.alertIdList,
      _postData
    );
  }
  getTranslate(domainType: any) {
    return this.http.get('assets/i18n/' + domainType + '.json');
  }

  /**
   * Toasters handler function
   * @param statusDtls
   */
  toasterService(statusDtls: any) {
    if (!this._sessionTimeoutFlag) {
      switch (statusDtls.type) {
        case 'success':
          this.toastr.success(statusDtls.msg, statusDtls?.title ?? 'Success', {
            positionClass: 'toast-top-right',
            toastClass: 'toast-icon custom-toast-success',
            timeOut: 5000,
          });
          break;
        case 'warning':
          this.toastr.warning(statusDtls.msg, statusDtls?.title ?? 'Warning', {
            positionClass: 'toast-top-right',
            toastClass: 'toast-icon custom-toast-warning',
          });
          break;
        case 'error':
          this.toastr.error(statusDtls.msg, statusDtls?.title ?? 'Error', {
            positionClass: 'toast-top-right',
            toastClass: 'toast-icon custom-toast-error',
          });
          break;
        default:
          this.toastr.warning(statusDtls.msg, statusDtls?.title ?? 'Warning', {
            positionClass: 'toast-top-right',
            toastClass: 'toast-icon custom-toast-warning',
          });
          break;
      }
    }
  }

  /* Get Plant list */
  plantList(page: any, searchKey?: any, isActiveFilter?: any) {
    const postData = {
      searchKey: searchKey,
      siteId: this.getSiteId(),
      status: isActiveFilter,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      `${ApiConstants.URL.plantList}/${page}`,
      postData
    );
  }

  /* People Pagination */
  peoplePagination(event: any, paginator: any) {
    if (event) {
      paginator.pageIndex = event.pageIndex;
      paginator.pageSize = event.pageSize;
      paginator.page.emit();
    }
  }

  /* Pagination */
  pagination(
    event: any,
    currentLength: any,
    currentPage: any,
    currentSize: any,
    list?: HTMLCollectionOf<Element>
  ) {
    list = document.getElementsByClassName('mat-paginator-range-label');
    if (event) {
      currentLength = event.length;
      currentPage = event.pageIndex;
      currentSize = event.pageSize;
    }
    let from = currentSize * currentPage + 1;
    let to =
      currentLength < currentSize * (currentPage + 1)
        ? currentLength
        : currentSize * (currentPage + 1);
    let toFrom = currentLength == 0 ? 0 : `${from} - ${to}`;
    let pageNumber =
      currentLength == 0
        ? `0 of 0`
        : `${currentPage + 1} of ${
            currentLength % currentSize > 0
              ? Math.floor(currentLength / currentSize) + 1
              : Math.floor(currentLength / currentSize)
          }`;
    let rows = `Page ${pageNumber} (${toFrom} of ${currentLength})`;
    if (list!.length >= 1) list![0].innerHTML = rows;
  }

  /* Filter Functionality */
  filter(event: any, dataSource: any) {
    const filterValue = (event.target as HTMLInputElement).value;
    dataSource.filter = filterValue.trim().toLowerCase();
    if (dataSource.paginator) {
      dataSource.paginator.firstPage();
    }
  }

  /* Go To Functionality */
  gotoFunctionality(event: any, paginator: any) {
    paginator.pageIndex = event - 1;
    const value: PageEvent = {
      length: paginator.length,
      pageIndex: paginator.pageIndex,
      pageSize: paginator.pageSize,
    };
    paginator.page.next(value);
  }

  /* create Plant */
  createPlant(siteDetails: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.createPlant,
      { siteDetails }
    );
  }

  /* delete Plant */
  deletePlant(siteId: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.deletePlant,
      { siteId }
    );
  }

  /* edit Plant */
  updatePlant(siteId: any, siteDetails: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.updatePlant,
      { siteId, siteDetails }
    );
  }

  /* Site List */
  siteList(siteId: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.siteList,
      { siteId }
    );
  }

  /**
   * Gets site list
   * @param [isLoaderNeeded]
   * @returns
   */
  getSiteList(isLoaderNeeded: boolean = true) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.siteList,
      {},
      isLoaderNeeded
    );
  }

  /* Get Plant details */
  siteDetails(siteId: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.siteDetails,
      { siteId }
    );
  }

  /* bulk upload */
  bulkUpload(file: any, type: string) {
    const payload: FormData = new FormData();
    payload.append(type, file, file.name);
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.bulkUpload,
      payload
    );
  }

  /* revokePassowrd */
  revokePassword(_id: any) {
    const payload = { userId: _id };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.revokePassword,
      payload
    );
  }

  /* user groups */
  userGroupPeople() {
    const payload = { index: localStorage.getItem('index') };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.userGroupPeople,
      payload
    );
  }

    /**
   * Gets user groups
   * @param [filter]
   * @param [isLoaderNeeded]
   * @returns
   */
     getUserGroups(filter?: { status?: boolean; type?: 'all' | 'level'; }, isLoaderNeeded: boolean = true) {
      let httpParams = new HttpParams();
      if (filter?.status) {
        httpParams = httpParams?.set('status', filter?.status);
      }
      if (filter?.type) {
        httpParams = httpParams?.set('type', filter?.type);
      }
      return this.httpGuard.httpReq(
        'get',
        'API_ENDPOINT',
        ApiConstants.URL.getUserGroups,
        httpParams?.toString() ? '?' + httpParams?.toString() : null,
        isLoaderNeeded
      );
    }

  /**
   * Zones details
   * @param payload
   * @param [offset]
   * @param [isLoaderNeeded]
   * @returns
   */
  zoneDetails(
    payload: ZoneDetailPayloadModel,
    offset: number = null,
    isLoaderNeeded: boolean = true
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.zoneDetails + offset,
      payload,
      isLoaderNeeded
    );
  }

  /**
   * Gets zone order
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  getZoneOrder(payload: ZoneOrderPayloadModel, isLoaderNeeded: boolean = true) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getZoneOrder,
      payload,
      isLoaderNeeded
    );
  }

  /* Delete Zone */
  deleteZone(zoneId: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.deleteZone,
      { zoneId }
    );
  }

  /* employees Mapping Info */
  // employeesMappingInfo(zoneId: any, siteId: any, empId: any, name?: any, contractorId?: any, roleId?: any, tradeId?: any) {
  //   return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.employeesMappingInfo, { zoneId, siteId, empId, name, contractorId, roleId, tradeId });
  // }

  /* Allocate Zones */
  allocateZones(zoneId: any, siteId: any, action: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.allocateZones,
      { zoneId, siteId, action }
    );
  }

  /* Zone Icon Info */
  zoneIconInfo() {
    return this.httpGuard.httpReq(
      'get',
      'API_ENDPOINT',
      ApiConstants.URL.zoneIconInfo
    );
  }

  /* Site Hierarchy Info */
  siteHierarchyInfo(siteId: any, isLoaderNeeded : boolean = false) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.siteHierarchyInfo,
      { siteId: siteId },
      isLoaderNeeded
    );
  }

  /* Zone Hierarchy */
  getZoneHierarchy(siteId: any, order: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getZoneHierarchy,
      { siteId, order }
    );
  }

  /* Template List */
  getTemplates() {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getTemplates,
      {}
    );
  }

  /* Create New Zone */
  createNewZone(
    siteId: any,
    classType: any,
    fileData: any,
    zoneDetails?: any,
    ptwDetails?: any,
    zoneId?: any,
    employeeList?: any,
    action?: any
  ) {
    const formData = {
      siteId: siteId,
      class: classType,
      zoneDetails: zoneDetails,
      ptwDetails: ptwDetails ?? null,
      zoneId: zoneId ?? null,
      employeeList: employeeList ?? null,
      action: action ?? null,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.createNewZone,
      formData
    );
  }

  /* Update New Zone */
  updateZoneDetails(
    name: any,
    siteId: any,
    zoneDetails: any,
    zoneId: any,
    fileData: any = null,
    relativePath: any = null,
    type: any = null,
    actionType: any = null
  ) {
    // const formData: FormData = new FormData();
    // if (fileData) {
    //   formData.append('avatar', fileData, fileData.name);
    // }
    // formData.append('name', name)
    // formData.append('siteId', siteId)
    // formData.append('zoneDetails', JSON.stringify(zoneDetails))
    // formData.append('zoneId', zoneId)
    // if (relativePath) { formData.append('relativePath', relativePath) }
    // if (type) { formData.append('type', type) }
    const formData = {
      siteId: siteId,
      name: name,
      zoneDetails: zoneDetails,
      zoneId: zoneId,
      fileData: fileData,
      relativePath: relativePath,
      type: type,
      actionType: actionType,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.updateZoneDetails,
      formData
    );
  }

  /* ptzList*/
  getPtwList(page: any) {
    const payload = {
      siteId: sessionStorage.getItem('plantProfileSiteId')
        ? JSON.parse(sessionStorage.getItem('plantProfileSiteId') || '{}')
        : null,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      `${ApiConstants.URL.getPtwList}/${page}`,
      payload
    );
  }

  /* viewPtw */
  viewPtw(ptwData: any) {
    const payload = {
      siteId: sessionStorage.getItem('plantProfileSiteId')
        ? JSON.parse(sessionStorage.getItem('plantProfileSiteId') || '{}')
        : null,
      // 'siteId' :'62f0d491c744900f83e31961',
      zoneId: ptwData?.zoneId,
      ptwId: ptwData?.eventId,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.viewPtw,
      payload
    );
  }

  /* deleteZone */
  deletePtwZones(item: any) {
    const payload = {
      siteId: sessionStorage.getItem('plantProfileSiteId')
        ? JSON.parse(sessionStorage.getItem('plantProfileSiteId') || '{}')
        : null,
      eventId: item?.tableData?.eventId,
      zoneId: item?.tableData?.zoneId,
      action: true,
      remarks: item.remark,
      state: 'canceled',
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.deletePtwZones,
      payload
    );
  }

  /* createZone */
  createZone(formData: any, mapDtls: any) {
    const payload = {
      siteId: sessionStorage.getItem('plantProfileSiteId')
        ? JSON.parse(sessionStorage.getItem('plantProfileSiteId') || '{}')
        : null,
      class: 'ptw',
      zoneDetails: formData?.zone?._id
        ? null
        : {
            name: formData?.zoneName,
            level: formData?.level?.level,
            centroid: mapDtls?.centroid,
            attribute: mapDtls?.attribute,
            restrictedAccess: {
              status: true,
              start: formData?.fromTime,
              timeZone: formData?.timeZone?.value,
              end: formData?.toTime,
            },
            hierarchy: formData?.hierarchy?._id,
            // order: formData?.hierarchy?.order,
            order: 99,
            geofencing: mapDtls?.polygen,
          },
      zoneId: formData?.zone?._id ? formData?.zone?._id : null,
      ptwDetails: {
        ptw: {
          type: formData?.ptwType?.name,
          mandatory: formData?.ptwAccess,
          description: formData?.description,
          fromTime: formData?.fromTime,
          toTime: formData?.toTime,
          timeZone: formData?.timeZone?.value,
          fromDate: formData?.fromDate,
          toDate: formData?.toDate,
        },
      },
      action: true,
      userList: formData?.attachUser
        ? formData?.attachUser
            .filter((item: any) => item.isMapped)
            .map((element: any) => element._id)
        : [],
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.createNewZone,
      payload
    );
  }

  /* updatePtwZoneDetails */
  updatePtwZoneDetails(formData: any, existingData: any) {
    const payload = {
      ptwDetails: {
        ptw: {
          type: formData?.ptwType?.name,
          mandatory: formData?.ptwAccess,
          description: formData?.description,
          fromTime: formData?.fromTime,
          toTime: formData?.toTime,
          timeZone: formData?.timeZone?.value,
          fromDate: formData?.fromDate,
          toDate: formData?.toDate,
        },
      },
      siteId: existingData?.siteId,
      zoneId: existingData?._id,
      ptwId: existingData?.ptw?.id,
      newPtw: existingData?.ptw?.newPtw,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.updatePtwZoneDetails,
      payload
    );
  }

  /* availableReaZones */
  availableReaZones() {
    const payload = {
      siteId: sessionStorage.getItem('plantProfileSiteId')
        ? JSON.parse(sessionStorage.getItem('plantProfileSiteId') || '{}')
        : null,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.availableReaZones,
      payload
    );
  }

  /* heirarchy */
  zoneOrderData() {
    const payload = {
      siteId: sessionStorage.getItem('plantProfileSiteId')
        ? JSON.parse(sessionStorage.getItem('plantProfileSiteId') || '{}')
        : null,
      order: 99,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.zoneOrderData,
      payload
    );
  }

  unallocatedPtwUsers(zoneId: any) {
    const payload = {
      siteId: sessionStorage.getItem('plantProfileSiteId')
        ? JSON.parse(sessionStorage.getItem('plantProfileSiteId') || '{}')
        : null,
      zoneId: zoneId,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.unallocatedPtwUsers,
      payload
    );
  }

  ptwUsersAllocation(empDetails: any, empList: any) {
    const payload = {
      siteId: sessionStorage.getItem('plantProfileSiteId')
        ? JSON.parse(sessionStorage.getItem('plantProfileSiteId') || '{}')
        : null,
      zoneId: empDetails?.item?.zoneId,
      empList: empList,
      ptwId: empDetails?.item?.eventId,
      action: true,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.ptwUsersAllocation,
      payload
    );
  }

  availableSites(userId: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.availableSites,
      userId
    );
  }

  userSiteAllocation(mappingDtls: any, userDtls: any) {
    const payload = {
      userId: userDtls.userId,
      action: userDtls.action,
      siteId: mappingDtls?.plant?._id,
      restrictedAccess: mappingDtls?.restrictedAccess,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.userSiteAllocation,
      payload
    );
  }

  zoneUserAllocation(empDetails: any, empList: any) {
    const payload = {
      siteId: sessionStorage.getItem('plantProfileSiteId')
        ? JSON.parse(sessionStorage.getItem('plantProfileSiteId') || '{}')
        : null,
      zoneId: empDetails?.item?._id,
      action: empList,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.zoneUsersAllocation,
      payload
    );
  }

  userMappingDetails(userDtls: any) {
    const payload = {
      userId: userDtls.userId,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.userMappingDetails,
      payload
    );
  }

  getSiteInfo() {
    return this.httpGuard.httpReq(
      'get',
      'API_ENDPOINT',
      ApiConstants.URL.getSiteInfo
    );
  }

  /* Logs */
  getLogs() {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getLogs,
      {}
    );
  }

  /**
   * Entities list
   * @param payload
   * @param page
   * @param [isLoaderNeeded]
   * @returns
   */
  entitiesList(
    payload: Partial<EntityListPayloadModel>,
    page: number,
    isLoaderNeeded: boolean = true,
    pageType?: string
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      `${ApiConstants.URL.entitiesList}/${page}`,
      payload,
      isLoaderNeeded,
      'events',
      pageType
    );
  }

  getAlertsCount(
    reqData: any,
    isLoaderNeeded: boolean = true,
    pageType?: string
  ) {
    const payload = {
      filterBy: reqData?.filterBy === 'null' ? null : reqData?.filterBy,
      from: reqData.from ? reqData.from : null,
      to: reqData.to,
      autoClose: reqData?.autoClose,
      status: null,
      severity: null,
      alert: null,
      category: null,
      classType: reqData?.classType === 'null' ? null : reqData?.classType,
      entityId: reqData.entityId ? reqData.entityId : null,
      siteId: reqData.siteId,
      entityCategory: reqData?.entityCategory,
      zoneId: reqData?.zoneId,
      ...(reqData.searchKey && { searchKey: reqData.searchKey }),
    };
    reqData?.filterList?.map((item: any) => {
      if (item.type === 'Severity') {
        payload.severity = item.value;
      }
      if (item.type === 'Alert') {
        payload.alert = item.value;
      }
      if (item.type === 'Status') {
        payload.status = item.value === 'active' ? true : false;
      }
      if (item.type === 'Category') {
        payload.category = item.value;
      }
    });
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.alertsCountList,
      payload,
      pageType==='vehicleList'?true:false,
      'events',
      pageType
    );
  }

  alertList(reqData: any, isLoaderNeeded: boolean = true) {
    const payload = {
      filterBy: reqData?.filterBy,
      from: reqData.from ? reqData.from : null,
      to: reqData.to,
      autoClose: reqData?.autoClose,
      status: null,
      severity: null,
      alert: null,
      category: null,
      classType: reqData?.classType,
      entityId: reqData.entityId ? reqData.entityId : null,
      siteId: reqData.siteId,
      entityCategory: reqData?.entityCategory,
      zoneId: reqData?.zoneId,
      limit: reqData?.limit,
      ...(reqData.searchKey && { searchKey: reqData.searchKey }),
    };
    reqData?.filterList?.map((item: any) => {
      if (item.type === 'Severity') {
        payload.severity = item.value;
      }
      if (item.type === 'Alert') {
        payload.alert = item.value;
      }
      if (item.type === 'Status') {
        payload.status = item.value === 'active' ? true : false;
      }
      if (item.type === 'Category') {
        payload.category = item.value;
      }
    });
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      `${ApiConstants.URL.alertList}/${reqData.page}`,
      payload,
      isLoaderNeeded
    );
  }

  getVehicleDetails(vehicleId: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.vehicleProfile,
      vehicleId
    );
  }

  getEntityDetails(entityId: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.entityProfile,
      entityId
    );
  }

  fetchPreSignedUrl(formData: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.fetchPreSignedUrl, formData
    );
  }

  getPresignedUrls(urls: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getPresignedUrls,
      urls
    );
  }

  blobUpload(blobDetails: any) {
    const siteId = JSON.parse(sessionStorage.getItem('siteId') || '{}')
      ? JSON.parse(sessionStorage.getItem('siteId') || '{}')
      : 'global';
    const dateTime = new DatePipe('en-US').transform(
      Date.now(),
      'YYYYMMddHHmmssSSSS'
    );
    const content = blobDetails?.file;
    const blobName =
      '/' +
      blobDetails?.baseUrl +
      siteId +
      '/' +
      dateTime +
      '_' +
      blobDetails?.file?.name.trim().replaceAll(' ', '_');
    const url = blobDetails?.preSignedUrl ?? 
      ApiConstants.URL.blobUpload +
      '/' +
      blobDetails.container +
      blobName +
      ApiConstants.blobSasToken;
    return this.httpGuard.httpReq('put', 'azureBlobBaseUrl', url, content);
  }

  blobDelete(blobUrl: any) {
    return this.httpGuard.httpReq('delete', 'azureBlobBaseUrl', blobUrl);
  }

  createKnowledgeBase(body: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.createKnowledgeBase,
      body
    );
  }

  updateKnowledgeBase(body: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.updateKnowledgeBaseDetails,
      body
    );
  }

  getKnowledgeBaseList(page: number, body: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      `${ApiConstants.URL.getKnowledgeBaseList}/${page}`,
      body
    );
  }

  getKnowledgeBaseDetails(body: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getKnowledgeBaseDetails,
      body
    );
  }

  deleteKnowledgeBase(body: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.deleteknowledgeBase,
      body
    );
  }

  /**
   * Tracks entity
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  trackEntity(
    payload: Partial<EntityTrackPayloadModel>,
    pageNo: number,
    isLoaderNeeded: boolean = false
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      `${ApiConstants.URL.trackEntity}/${pageNo}`,
      payload,
      this.getCustomLoaderCheck() ? false : isLoaderNeeded
    );
  }

  /**
   * Alerts count
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  alertsCount(
    payload: Partial<EntityAlertsCountPayloadModel>,
    isLoaderNeeded: boolean = false
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.alertsCount,
      payload,
      this.getCustomLoaderCheck() ? false : isLoaderNeeded
    );
  }

  locateEntity(requestData: any) {
    const payload = {
      entityId: requestData.entityId ? requestData.entityId : null,
      siteId: requestData.siteId ? requestData.siteId : null,
      from: requestData.from ? requestData.from : null,
      to: requestData.to ? requestData.to : null,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.locateEntity,
      payload,
      false
    );
  }
  entityCategories(requestData: any) {
    const payload = {
      siteId: requestData.siteId ? requestData.siteId : null,
      from: requestData.from ? requestData.from : null,
      isActive: requestData?.isActive,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.entityCategories,
      payload
    );
  }

  // activeEntities(reqData) {
  //   const payload = {
  //     siteId: sessionStorage.getItem('siteId') ?
  //       JSON.parse(sessionStorage.getItem('siteId') || '{}') : null,
  //     from: reqData.from ? reqData.from : null,
  //     to: reqData.to ? reqData.to : null
  //   }

  //   return this.http.post(ApiConstants.URL.activeEntities, payload);
  // }

  // scoreBasedEntities() {
  //   return this.http.post(ApiConstants.URL.scoreBasedEntities, {});
  // }

  getFileExtension(value: string) {
    return value
      ? value.substring(value.lastIndexOf('.') + 1).split('?')[0]
      : null;
  }

  getFileSupportStatus(fileMimeType: string, supportFileMimeTypes: string[]) {
    let status = false;
    if (fileMimeType && supportFileMimeTypes?.length) {
      status = supportFileMimeTypes.includes(fileMimeType);
    }
    return status;
  }

  getFileTypeImage(value: string) {
    const fileExtension = this.getFileExtension(value);
    let fileTypeImage: string = 'blob_unsupported.svg';
    switch (fileExtension?.toLowerCase()) {
      case 'doc':
      case 'docx':
      case 'pdf':
      case 'ppt':
      case 'pptx':
      case 'xls':
      case 'xlsx':
        fileTypeImage = 'blob_document.svg';
        break;
      case 'mp4':
      case 'webm':
      case 'avi':
        fileTypeImage = 'blob_video.svg';
        break;
      case 'mp3':
      case 'wav':
        fileTypeImage = 'blob_audio.svg';
        break;
      case 'apng':
      case 'avif':
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
      case 'webp':
        fileTypeImage = 'blob_image.svg';
        break;
    }
    return fileTypeImage;
  }

  convertBytesToMegaBytes(value: number, roundTo: number = 2) {
    // Value in bytes
    let returnValue: number;
    if (value) {
      const megaBytes = value / (1024 * 1024);
      returnValue = roundTo ? +megaBytes.toFixed(roundTo) : megaBytes;
    }
    return returnValue;
  }

  getFileExtensionFromUrl(url: string) {
    let extension = '';
    if (url) {
      extension = url.substring(url.lastIndexOf('.') + 1).split('?')[0];
    }
    return extension;
  }

  getFileNameFromUrl(url: string) {
    let extension = '';
    if (url) {
      extension = url.substring(url.lastIndexOf('/') + 1).split('?')[0];
    }
    return extension;
  }

  // entityInfo(reqData) {
  //   const payload = {
  //     siteId: reqData.siteId,
  //     from: reqData.from,
  //     to: reqData.to
  //   };
  //   return this.http.post(ApiConstants.URL.entityInfo, payload);
  // }

  // alertStatistics(reqData) {
  //     const payload = {
  //       from:  reqData.from,
  //       to:  reqData.to,
  //       siteId: reqData.siteId
  //   };
  //   return this.http.post(ApiConstants.URL.alertStatistics, payload);
  // }

  getKnowledgeBaseStatistics() {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getKnowledgeBaseStatistics,
      {}
    );
  }

  getEntityAttribute(reqData) {
    const payload = {
      siteId: reqData.siteId,
      from: reqData.from,
      to: reqData.to,
      entityId: reqData.entityId,
      attributes: reqData?.attributes,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.entityAttributes,
      payload,
      false
    );
  }

  getEntityAttributeV1(reqData) {
    const payload = {
      siteId: reqData.siteId,
      from: reqData.from,
      to: reqData.to,
      entityIds: reqData.entityIds,
      attributes: reqData?.attributes,
      source: reqData?.source ?? 'heartbeat',
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.entityAttributesV1,
      payload,
      false
    );
  }

  permissionManagement(permissionToCheck: any) {
    const token = this.jwtHelper.decodeToken(localStorage.getItem('token'));
    if (token && token?.user?.privilege && token?.user?.privilege?.length) {
      return token.user.privilege.includes(permissionToCheck);
    } else {
      localStorage.clear();
      this.router.navigate(['login']);
      return false;
    }
  }

  getLastSeenFormat(sourceTimestamp: any) {
    if (!sourceTimestamp) return null;
    const dateDiff = Math.floor(
      (new Date().valueOf() - new Date(sourceTimestamp).valueOf()) /
        (1000 * 60 * 60 * 24)
    );
    if (!dateDiff) {
      const differ = new Date().getTime() - new Date(sourceTimestamp).getTime();
      const days = Math.floor(differ / (60 * 60 * 24 * 1000));
      const hours = Math.floor(differ / (60 * 60 * 1000)) - days * 24;
      const minutes =
        Math.floor(differ / (60 * 1000)) - (days * 24 * 60 + hours * 60);
      const seconds =
        Math.floor(differ / 1000) -
        (days * 24 * 60 * 60 + hours * 60 * 60 + minutes * 60);
      return (
        (hours ? hours + ' Hours ' : '').toString() +
        (minutes
          ? minutes === 1
            ? minutes + ' Min'
            : minutes + ' Mins'
          : ''
        ).toString() +
        (!minutes && !hours ? ' Just Now' : ' Ago').toString()
      );
    } else {
      return '' + new DatePipe('en-US').transform(sourceTimestamp, 'medium');
      // return ''+ dateDiff + ' Days ago';
    }
  }

  // vehicleStatistics(reqData){
  //   const payload= {
  //     siteId: reqData.siteId
  //   }
  //   return this.http.post(ApiConstants.URL.vehicleStatistics, payload);
  // }

  getPrivilegeUrl() {
    const urlName = [...leftMainMenu.menu].find((item: any) =>
      this.rbacManagement(item.privilege)
    );
    return urlName ? urlName.nav : null;
  }

  routingPrivilegeCheck(moduleName: any) {
    const routeModule = [...leftMainMenu.menu].find(
      (item: any) => item.nav === moduleName
    );
    return this.rbacManagement(routeModule ? routeModule.privilege : null);
  }

  subMenuRoutingPrivilegeCheck(subMenuNav: any, moduleName: any) {
    if ([...leftSubMenu[moduleName]].length) {
      const routeModule = [...leftSubMenu[moduleName]].find(
        (item: any) => item.nav === subMenuNav
      );
      return this.rbacManagement(routeModule ? routeModule.privilege : null);
    } else {
      return true;
    }
  }

  syncConfigMessage(payload: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.syncConfigMessage,
      payload
    );
  }

  // fleetCategoryCount(reqData){
  //   const payload = {
  //     from: reqData.from,
  //     to: reqData.to,
  //     siteId: reqData.siteId
  //   };
  //   return this.http.post(ApiConstants.URL.fleetCategoryCount, payload);
  // }

  chatGptGetMsg(botInput: any) {
    const payload = {
      modelRequest: {
        prompt: botInput,
        additionalInfo: {
          timestamp: this.datePipe.transform(
            new Date(),
            'yyyy-MM-ddTHH:mm:ssZ'
          ),
          timezone: moment.tz.guess(),
          tenantId: localStorage.getItem('tenantId')
            ? localStorage.getItem('tenantId')
            : null,
        },
      },
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.chatRequest,
      payload,
      false
    );
  }

  /**
   * Gets chat response
   * @param botInput
   * @returns
   */
  getChatResponse(botInput: any) {
    const params =
      '?query=' + botInput.trim().replaceAll(/\s+/g, '+') + '&roles=' + 'admin';
    return this.httpGuard.httpReq(
      'get',
      'API_ENDPOINT',
      ApiConstants.URL.chatRequestV1,
      params,
      false
    );
  }

  /**
   * Bots proceed
   * @param reqDetails
   * @returns
   */
  botProceed(reqDetails: any) {
    const method = reqDetails?.method?.toLowerCase();
    return this.httpGuard.httpReq(
      reqDetails?.method,
      null,
      reqDetails?.url,
      method !== 'get' ? reqDetails?.details : null,
      false
    );
  }

  updatedwidgets(payload: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.updateWidgets,
      payload
    );
  }

  widgets(menu: any) {
    const payload = {
      appId: '630c71678c8c40048e2fc9cc',
      menu: menu,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.widgets,
      payload
    );
  }

  /**
   * Icons list
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  iconList(
    payload: Partial<EntityIconListPayloadModel>,
    isLoaderNeeded: boolean = false,
    pagetype?: string
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.entityIconList,
      payload,
      isLoaderNeeded,
      'events',
      pagetype
    );
  }

  getMenuBasedOnUrl(url: any): any {
    if (url.includes('vehicles/profile')) {
      return 2;
    }
    if (url.includes('assets/profile')) {
      return 3;
    }
    if (url.includes('people/profile')) {
      return 4;
    }
  }

  getUrlType(url: any): any {
    if (url.includes('vehicles')) {
      return 1;
    }
    if (url.includes('assets')) {
      return 2;
    }
    if (url.includes('people')) {
      return 3;
    }
  }

  filterInputData(
    payload: FilterInputDataPayloadModel,
    isLoaderNeeded: boolean = true
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.filterInputData,
      payload,
      isLoaderNeeded
    );
  }

  availableSupervisors(payload: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.availableSupervisors,
      payload
    );
  }

  entitySupervisorAllocation(reqData: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.entitySupervisorAllocation,
      reqData
    );
  }

  entitySiteAllocation(reqData: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.entitySiteAllocation,
      reqData
    );
  }

  entitySiteDeallocation(reqData: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.entitySiteDeallocation,
      reqData
    );
  }

  notifyUser(notifyPayload: any) {
    delete notifyPayload['toUser'];
    const payload = { userDetails: notifyPayload };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.notifyUser,
      payload
    );
  }

  setConfiguration(configurationList: any) {
    this.masterConfigurationList = JSON.stringify(configurationList);
  }

  getConfiguration(attributeName: string, returnValue: string = 'values') {
    if (this.masterConfigurationList && this.masterConfigurationList.length) {
      const configuration = JSON.parse(this.masterConfigurationList).find(
        (elem: any) => elem.attribute === attributeName
      );
      if (configuration) {
        return returnValue === 'values' ? configuration.values : configuration;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  setLeafletData(data: any) {
    this.masterLeafletData = data;
  }

  getLeafletData() {
    return this.masterLeafletData;
  }

  flattenObject(obj: any, pageType: string = null) {
    let result = {};
    for (const i in obj) {
      if (typeof obj[i] === 'object' && !Array.isArray(obj[i])) {
        const temp = this.flattenObject(obj[i]);
        for (const j in temp) {
          result[j] = temp[j];
        }
      } else {
        result[i] = obj[i];
      }
    }
    if (pageType === 'patientMonitoring') {
      if (
        new Date(result['sourceTimestamp']) >
        new Date(new Date().setMinutes(new Date().getMinutes() - 15))
      ) {
        result['attributes']?.forEach((attr: any) => {
          result[attr.attributeName] = attr['attributeValue'];
        });
      }
    } else if (pageType === 'vitals') {
      result['attributes']?.forEach((attr: any) => {
        result[attr.attributeName] = attr['attributeValue'];
      });
    }
    return result;
  }

  availableDevices(payload: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.availableDevices,
      payload
    );
  }

  entityDeviceAllocation(entityDeviceAllocationPayload: any) {
    const payload = {
      siteId: entityDeviceAllocationPayload?.siteId,
      deviceId: entityDeviceAllocationPayload?.deviceId,
      deviceType: entityDeviceAllocationPayload?.deviceType,
      currentTime: entityDeviceAllocationPayload.currentTime,
      entityId: entityDeviceAllocationPayload?.entityId,
      attributes: entityDeviceAllocationPayload?.attribute,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.entityDeviceAllocation,
      payload
    );
  }

  entityDeviceDeallocation(entityDeviceDeallocationPayload: any) {
    const payload = {
      siteId: entityDeviceDeallocationPayload.siteId,
      deviceId: entityDeviceDeallocationPayload.deviceId,
      deviceType: entityDeviceDeallocationPayload.deviceType,
      currentTime: entityDeviceDeallocationPayload.currentTime,
      entityId: entityDeviceDeallocationPayload.entityId,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.entityDeviceDeallocation,
      payload
    );
  }

  exportEntityData(payload: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.exportEntityData,
      payload
    );
  }

  pushNotification(notification: any) {
    let notificationList: any = sessionStorage.getItem('masterNotificationList')
      ? JSON.parse(sessionStorage.getItem('masterNotificationList'))
      : [];
    if (notificationList.length <= 50) {
      notificationList.push(notification);
    } else {
      notificationList.shift();
      notificationList.push(notification);
    }
    sessionStorage.setItem(
      'masterNotificationList',
      JSON.stringify(notificationList)
    );
  }

  getPlanogramData(type: string) {
    const params = '?siteId=' + this.getSiteId() + '&category=monotainer';
    return this.httpGuard.httpReq(
      'get',
      'API_ENDPOINT',
      ApiConstants.URL.planogramData,
      params,
      type === 'default' ? true : false
    );
  }

  getZoneHistory(payload: any) {
    const encodedFrom = encodeURIComponent(payload?.from);
    const encodedTo = encodeURIComponent(payload?.to);
    const params = this.getSiteId()
      ? '/zones/history?category=monotainer&action=tagDestination&siteId=' +
        this.getSiteId() +
        '&from=' +
        encodedFrom +
        '&to=' +
        encodedTo
      : '/zones/history?category=monotainer&action=tagDestination&from=' +
        encodedFrom +
        '&to=' +
        encodedTo;
    return this.httpGuard.httpReq(
      'get',
      'API_ENDPOINT',
      ApiConstants.URL.fetchLanes,
      params
    );
  }

  forceClear(payload: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.fetchLanes +
        '/' +
        this.getSiteId() +
        '/zones/forceClear',
      payload
    );
  }

  // Create Service Now Ticket
  createServiceTicket(data: any, isLoaderNeeded: boolean = true) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.serviceNow,
      data,
      isLoaderNeeded
    );
  }

  // Get Service Now Tickets
  getServiceTicket(isLoaderNeeded: boolean = true) {
    return this.httpGuard.httpReq(
      'get',
      'API_ENDPOINT',
      ApiConstants.URL.serviceNow,
      null,
      isLoaderNeeded
    );
  }

  getImageList(reqData: any) {
    const params = '?page=' + reqData?.offset + '&count=' + reqData?.limit;
    return this.httpGuard.httpReq(
      'get',
      'API_ENDPOINT',
      ApiConstants.URL.imageList,
      params
    );
  }

  saveImage(payload: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.saveImage,
      payload
    );
  }

  generateEmptyTableRow(columnHeader: any, rowNeeded: number = 3) {
    Object.keys(columnHeader).forEach(
      (elem: string) => (columnHeader[elem] = null)
    );
    let tableData = [];
    for (let i = 0; i < rowNeeded; i++) {
      tableData.push(columnHeader);
    }
    return tableData;
  }

  resetRULDetials(rulClass: string) {
    const rulConfig = this.getConfiguration('trlRulConfig')
      ? this.getConfiguration('trlRulConfig')?.trlRulConfig?.find(
          (item: any) => item.model === 'safari'
        )
      : [];
    return rulConfig?.partsLifetime?.find(
      (item: any) => item?.class === rulClass
    );
  }

  externalAuthentication(token: string) {
    const payload = {
      entityToken: token,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.externalAuthentication,
      payload,
      false
    );
  }

  getConfigurationBasedOnCategory(entityDetails: any, type?: string) {
    const entityConfig = (type === 'export' && this.getConfiguration('exportGenericConfig')) ? this.getConfiguration('exportGenericConfig') : (this.getConfiguration('tenantGenericConfig')
      ? this.getConfiguration('tenantGenericConfig')
      : null);
    const entityCategoryConfig = entityConfig?.profile
      ? entityConfig?.profile
      : null;
    if (entityCategoryConfig?.length && entityDetails?.category) {
      const filteredCategoryConfig = entityConfig?.profileCategorizationKey
        ? entityCategoryConfig?.filter(
            (elem: any) =>
              elem?.category ===
              entityConfig?.profileCategorizationKey
                ?.split('.')
                .reduce((obj, key) => obj?.[key], entityDetails)
          )
        : entityCategoryConfig.filter(
            (elem: any) => elem?.category === entityDetails?.category
          );
      if (
        filteredCategoryConfig?.length &&
        entityDetails?.primaryDetails?.make
      ) {
        const filteredMakeConfig = filteredCategoryConfig.find(
          (item: any) => item?.make === entityDetails?.primaryDetails?.make
        );
        return filteredMakeConfig
          ? filteredMakeConfig
          : filteredCategoryConfig[0];
      } else {
        return filteredCategoryConfig.length ? filteredCategoryConfig[0] : null;
      }
    } else {
      return entityConfig ? entityConfig : null;
    }
  }

  setRbacList(hierarchy: boolean = false, response?: any) {
    const params = '?hierarchy=' + hierarchy;
    this.httpGuard
      .httpReq('get', 'API_ENDPOINT', ApiConstants.URL.features, params)
      .subscribe({
        next: (data: any) => {
          if (data?.length) {
            this.masterRbacList = [...data]?.map((elem: any) => elem.uniqueId);
            localStorage.setItem('rbac', JSON.stringify(this.masterRbacList));
            if (this.getPrivilegeUrl())
              if (response)
                this.router.navigateByUrl(this._getRedirectUrl(response));
              else this.router.navigateByUrl(this.getPrivilegeUrl());
          } else {
            this.noPrivilegeHanlde();
          }
        },
        error: () => {
          this.noPrivilegeHanlde();
        },
      });
    // }
  }

  noPrivilegeHanlde(toaster: boolean = true) {
    this.masterRbacList = [];
    localStorage.clear();
    this.router.navigate(['login']);
    if (toaster)
      this.toasterService({
        type: 'warning',
        msg: 'Sorry, you dont have relevant privilege to access the portal. Please contact admin and try again.',
      });
  }

  rbacManagement(privilege?: any) {
    if (this.masterRbacList?.length) {
      return this.masterRbacList?.includes(privilege);
    } else {
      const rbac = localStorage.getItem('rbac')
        ? JSON.parse(localStorage.getItem('rbac'))
        : [];
      if (rbac?.length) {
        this.masterRbacList = rbac;
        return this.masterRbacList?.includes(privilege);
      } else {
        this.noPrivilegeHanlde(false);
        return false;
      }
    }
  }

  resetRbac() {
    this.masterRbacList = [];
  }

  commonExport(
    fileType: string,
    exportRequest: any,
    endpoint: string,
    exportName: string,
    category?: string,
    entityId?: string,
    aggregate?: string,
    pageType?: string,
    from ?: string,
    to?: string
  ) {
    const extention = fileType === 'json' ? 'application/json' : 'text/csv';
    this.export(exportRequest, endpoint, category, entityId, aggregate, pageType).subscribe({
      next: (result: any) => {
        if (result?.status == 200) {
            const fromDate = this.datePipe.transform(from, 'dd_MMM_yyyy_HH_mm_ss');
            const toDate = this.datePipe.transform(to, 'dd_MMM_yyyy_HH_mm_ss');
          if (fileType === 'json') {
            let filename = exportName + entityId +'_'+fromDate + '-'+toDate;
            const blob = new Blob([result?.body], {
              type: extention + ';charset=utf-8',
            });
            downloadjs(
              blob,
              pageType === 'telematicsHistory' ? filename : (exportName +
                this.datePipe.transform(new Date(), 'yyyy_MM_dd_HH_mm_ss')),
              extention
            );
          } else {
            const contentDisposition = result?.headers?.get('Content-Disposition');
            let filename = (pageType === 'telematicsHistory' ?  (exportName + entityId +'_'+fromDate + '-'+toDate)  : (exportName + this.datePipe.transform(new Date(), 'yyyy_MM_dd_HH_mm_ss')));
            if (contentDisposition) {
              const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
              if (matches?.[1]) {
                filename = matches[1].replace(/['"]/g, ''); 
              }
            }
            downloadjs(
              result?.body,
              (pageType === 'bulk-upload' || pageType === 'telematicsHistory') ? filename: exportName + this.datePipe.transform(new Date(), 'yyyy_MM_dd_HH_mm_ss'),
              extention
            );
            if(pageType === 'bulk-upload') {
              this.toasterService({
                type: 'success',
                msg: 'Uploaded successfully',
              });
            }
          }
        }
      },
      error: (result) => {
        if(pageType === 'bulk-upload') {
          const contentDisposition = result?.headers?.get('Content-Disposition');
            let filename = exportName + this.datePipe.transform(new Date(), 'yyyy_MM_dd_HH_mm_ss');
            if (contentDisposition) {
              const matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
              if (matches?.[1]) {
                filename = matches[1].replace(/['"]/g, ''); 
              }
            }
            downloadjs(
              result?.error,
              filename,
              extention
            );
        } else {
            this.toasterService({
              type: 'error',
              msg: result?.error,
            });
          }
      },
    });
  }

  export(
    paramData: any,
    exportEndpoint: string,
    category?: string,
    entityId?: string,
    aggregate?: string,
    pageType?: string
  ) {
    if (category === 'monotainer')
      return this.httpGuard.httpReq(
        'post-csv-json',
        'API_ENDPOINT',
        '/v1/sites/' + `${entityId}` + `${ApiConstants.URL?.[exportEndpoint]}`,
        paramData
      );
    else if (category === 'history')
      return this.httpGuard.httpReq(
        'post-csv-json',
        'API_ENDPOINT',
        '/v1/entities/' +
          `${entityId}` +
          `${ApiConstants.URL?.[exportEndpoint]}`,
        paramData
      );
    else if (category === 'protusAggregate') 
    return this.httpGuard.httpReq(
      'post-csv-json',
      'API_ENDPOINT',
      `${ApiConstants.URL?.[exportEndpoint]}` + `?aggregate=` + `${aggregate}`,
      paramData
    );
    else if (pageType === 'bulk-upload')
      return this.httpGuard.httpReq(
        'post-csv-json-blob',
        'API_ENDPOINT',
        ApiConstants.URL?.[exportEndpoint],
        paramData,
        true,
        'events',
        pageType
      );
    else
      return this.httpGuard.httpReq(
        'post-csv-json',
        'API_ENDPOINT',
        ApiConstants.URL?.[exportEndpoint],
        paramData
      );
  }

  getTrend(requestData: any) {
    const payload = {
      from: requestData?.from,
      to: requestData?.to,
      attributes: requestData?.attributes,
      includeHistory: false,
    };
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL?.entitiesDetails +
        '/' +
        requestData?.entityId +
        '/trend',
      payload,
      false
    );
  }

  /**
   * Gets module metrics
   * @returns
   */
  getModuleMetrics(filter: ModuleHealthPayloadModel) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.entityModuleHealth,
      filter
    );
  }

  /**
   * Gets location from coordinates
   * @param latitude
   * @param longitude
   * @returns location from coordinates
   */
  getLocationFromCoordinates(
    latitude: string,
    longitude: string
  ): Observable<string | null> {
    const url = `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`;
    return this.http.get<any>(url).pipe(
      map((data) => data?.display_name),
      catchError((error) => {
        console.error('There was a problem with the fetch operation:', error);
        return null;
      })
    );
  }

  private _getRedirectUrl(details: any) {
    switch (details?.['entityType']) {
      case 1:
        return 'vehicles/profile/' + details?.['redirectTo'];
      case 2:
        return 'assets/profile/' + details?.['redirectTo'];
      case 3:
        return 'people/profile/' + details?.['redirectTo'];
      default:
        return 'home';
    }
  }

  /**
   * Sets mapping attribute
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  setMappingAttribute(
    payload: ThresholdEditPayloadModel,
    isLoaderNeeded: boolean = true
  ) {
    return this.httpGuard.httpReq(
      'patch',
      'API_ENDPOINT',
      ApiConstants?.URL?.mappingAttribute,
      payload,
      isLoaderNeeded
    );
  }

  /**
   * Gets peripheral metrics
   * @param filter
   * @returns peripheral metrics
   */
  getPeripheralMetrics(
    filter: DeviceStatisticsPayloadModel
  ): Observable<ResponseModel<PeripheralMetricsModel>> {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getPeripheralMetrics,
      { ...filter }
    );
  }

  /**
   * Gets peripheral history
   * @param filter
   * @param dataset
   * @returns peripheral history
   */
  getPeripheralHistory(
    filter: DeviceStatisticsPayloadModel,
    dataset: string
  ): Observable<ResponseModel<HistoryModel[]>> {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getPeripheralHistory,
      { ...filter, id: dataset }
    );
  }

  /**
   * Gets floor plan entities
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  getFloorPlanEntities(
    payload: Partial<ZonePlanEntityPayloadModel>,
    isLoaderNeeded: boolean = true
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.floorPlanEntities,
      payload,
      isLoaderNeeded
    );
  }

  /**
   * Creates entity location
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  createEntityLocation(
    payload: ZonePlanEntityLocationPayloadModel,
    isLoaderNeeded: boolean = true
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.createEntityLocation,
      payload,
      isLoaderNeeded
    );
  }

  /**
   * Updates entity location
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  updateEntityLocation(
    payload: ZonePlanEntityLocationPayloadModel,
    isLoaderNeeded: boolean = true
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.updateEntityLocation,
      payload,
      isLoaderNeeded
    );
  }

  /**
   * Deletes entity location
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  deleteEntityLocation(
    payload: ZonePlanEntityLocationDeletePayloadModel,
    isLoaderNeeded: boolean = true
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.deleteEntityLocation,
      payload,
      isLoaderNeeded
    );
  }

  /**
   * Entity aggregation
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  entityAggregation(
    payload: ZonePlanAggregationPayloadModel,
    isLoaderNeeded: boolean = false
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.entityAggregation,
      payload,
      isLoaderNeeded
    );
  }

  /**
   * Tracker entity count
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  trackerEntityCount(
    payload: ZonePlanTrackerEntityCountPayloadModel,
    isLoaderNeeded: boolean = false
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.trackerEntityCount,
      payload,
      isLoaderNeeded
    );
  }

  /**
   * Gets entity
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  getEntity(
    payload: EntityOnboardDataPayloadModel,
    isLoaderNeeded: boolean = true
  ) {
    let httpParams = new HttpParams();
    if (payload?.entityId) {
      httpParams = httpParams?.set('entityId', payload?.entityId);
    }
    return this.httpGuard.httpReq(
      'get',
      'API_ENDPOINT',
      ApiConstants?.URL?.getEntity,
      '?' + httpParams,
      isLoaderNeeded
    );
  }

  /**
   * Creates entity
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  createEntity(
    payload: EntityOnboardPayloadModel[],
    isLoaderNeeded: boolean = true
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.createEntity,
      payload,
      isLoaderNeeded
    );
  }

  /**
   * Updates entity
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  updateEntity(
    payload: EntityOnboardPayloadModel,
    isLoaderNeeded: boolean = true
  ) {
    const { _id, ...entityWithoutId } = payload?.['entity'];
    const finalPayload = {
      ...payload,
      entity: entityWithoutId
    };
    const url = _id
      ? `${ApiConstants?.URL?.updateEntity}/${_id}`
      : ApiConstants?.URL?.updateEntity;

    return this.httpGuard.httpReq(
      'put',
      'API_ENDPOINT',
      url,
      finalPayload,
      isLoaderNeeded,
      'response'
    );
  }

  /**
   * Gets common chart data
   * @param method
   * @param endPoint
   * @param payload
   * @param [isLoaderNeeded]
   * @returns
   */
  getCommonChartData(
    method: string,
    endPoint: string,
    payload: any,
    isLoaderNeeded: boolean = true
  ) {
    return this.httpGuard.httpReq(
      method,
      'API_ENDPOINT',
      endPoint,
      payload,
      isLoaderNeeded,
      'events',
      'widget'
    );
  }

  /**
   * Gets vehicle state
   * @param payload
   * @returns
   */
  getVehicleState(
    payload: { from: string; to: string; siteId?: string },
    isLoaderNeeded: boolean = true
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getVehicleState,
      payload,
      isLoaderNeeded,
      'events',
      'widget-state'
    );
  }

  /**
   * Gets module metrics
   * @returns
   */
  getVehicleType(
    payload: { from: string; to: string; siteId?: string; category?: string },
    isLoaderNeeded: boolean = true
  ) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getVehicleType,
      payload,
      isLoaderNeeded,
      'events',
      'widget'
    );
  }

  /**
   * Calculates date range
   * @param configHour
   * @returns date range
   */
  calculateDateRange(configHour: number): { startDate: Date; endDate: Date } {
    const now = new Date();
    const startOfToday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0,
      0
    );
    const startOfYesterday = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - 1,
      0,
      0,
      0,
      0
    );

    const configTimeToday = new Date(
      startOfToday.getTime() + configHour * 60 * 60 * 1000
    );
    const configTimeYesterday = new Date(
      startOfYesterday.getTime() + configHour * 60 * 60 * 1000
    );

    if (now < configTimeToday) {
      // Current time is before the configured hour today
      return {
        startDate: configTimeYesterday,
        endDate: configTimeToday,
      };
    } else {
      // Current time is after the configured hour today
      return {
        startDate: configTimeToday,
        endDate: now,
      };
    }
  }

  /**
   * Gets config start and end date
   * @param defaultTimeRange
   * @returns config start and end date
   */
  getConfigStartAndEndDate(defaultTimeRange: number): {
    startDate: Date;
    endDate: Date;
  } {
    const startOfToday = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate(),
      0,
      0,
      0,
      0
    );
    const startOfYesterday = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      new Date().getDate() - 1,
      0,
      0,
      0,
      0
    );

    // Add the configuration value (in hours) to both dates
    const configStartDate = new Date(
      startOfYesterday.getTime() + defaultTimeRange * 60 * 60 * 1000
    ); // Adding hours
    const configEndDate = new Date(
      startOfToday.getTime() + defaultTimeRange * 60 * 60 * 1000
    ); // Adding hours

    return { startDate: configStartDate, endDate: configEndDate };
  }

  formatToK(distance: number | string) {
    const units = [
      { value: 1e12, suffix: 'T' }, // Trillions
      { value: 1e9, suffix: 'B' }, // Billions
      { value: 1e6, suffix: 'M' }, // Millions
      { value: 1e3, suffix: 'k' }, // Thousands
    ];

    for (const unit of units) {
      if (Number(distance) >= unit.value) {
        return (
          (Number(distance) / unit.value).toFixed(1).replace(/\.0$/, '') +
          unit.suffix
        );
      }
    }

    return distance?.toString();
  }

  /**
   * Gets form field option
   * @param endpoint
   * @param method
   * @param payload
   * @returns
   */
  getFormFieldOption(endpoint: string, method: string, payload: UnknownModel) {
    return this.httpGuard.httpReq(
      method,
      'API_ENDPOINT',
      endpoint,
      payload,
      true
    );
  }

  /**
   * Gets tracker vehicle state
   * @param payload
   * @returns
   */
  getTrackerVehicleState(payload: {
    from: string;
    to: string;
    siteId?: string;
  }, isLoaderNeeded : boolean = false) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants.URL.getTrackerVehicleState,
      payload,
      isLoaderNeeded
    );
  }

  /**
   * Gets active dtc case count
   * @param payload
   * @returns
   */
  getActiveDtcCaseCount(payload: { entityIds: string[] }, isLoaderNeeded: boolean = false, pagetype?: string) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.fetchActiveDtcCaseCount,
      payload,
      isLoaderNeeded,
      'events',
      pagetype
    );
  }

  getAlertAnalyzeTelemetryConfig(fuelType: string, type?: string) {
    const entityConfig = (type === 'export' && this.getConfiguration('exportGenericConfig')) ? this.getConfiguration('exportGenericConfig') : (this.getConfiguration('tenantGenericConfig')
      ? this.getConfiguration('tenantGenericConfig')
      : null);
    const entityCategoryConfig = entityConfig?.alertAnalyze?.telemetry ?? null;
    if (entityCategoryConfig?.length && fuelType) {
      const filteredCategoryConfig = entityCategoryConfig.filter(
        (elem: any) => elem?.category === fuelType
      );
      return filteredCategoryConfig.length ? filteredCategoryConfig : null;
    } else {
      return null;
    }
  }

  setCaseFilters(caseFilter) {
    this.caseFilters = caseFilter;
  }

  getCaseFilters() {
    return this.caseFilters;
  }

  /**
   * Gets planogram summary details
   * @param payload
   * @returns
   */
  _getPlanogramSummary(payload: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.planogramSummary,
      payload,
      false
    );
  }

  /**
   * Gets planogram item TIS
   * @param payload
   * @returns
   */
  _getPlanogramTis(payload: any) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.planogramTis,
      payload,
      false
    );
  }

  /**
   * Gets planogram timelapse data for the specified entities
   * @param payload - The request payload containing entity IDs and time range
   * @returns Observable of timelapse data
   */
  _getPlanogramTimelapse(payload: any): Observable<any> {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.planogramTimeplase,
      payload,
      false
    );
  }

  /**
   * Gets planogram history data for the specified entities
   * @param payload - The request payload containing entity IDs and time range
   * @returns Observable of history data
   */
  _getPlanogramEntityHistory(payload: any): Observable<any> {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.planogramHistory,
      payload,
      true
    );
  }

  /**
   * Gets planogram history data for the specified entities
   * @returns boolean  value if key is available
   */
  getCustomLoaderCheck() {
    return (
      !!this.getConfiguration('tenantGenericConfig')?.entityCategories?.[
        'workBench'
      ] && !!sessionStorage.getItem('trackerSelectedTab')
    );
  }

  setRangeSelected(range) {
    this.rangeSelected = range;
  }

  getRangeSelected() {
    return this.rangeSelected;
  }

  setEntitiesFilter(value: string[]) {
    this.selectedEntitiesFromCHart = value;
  }

  getEntitiesFilter() {
    return this.selectedEntitiesFromCHart;
  }

  getScalingFactor(): number {
    const dpr = window.devicePixelRatio;
    let scalingFactor = 100;

    scalingFactor = dpr * 100 || 100;
    return scalingFactor;
  }

  setFilters(filter: any, module: string) {
    this.filtersApplied[module] = filter;
  }

  getFilters(field: string) {
    return this.filtersApplied ? this.filtersApplied?.[field] : {};
  }

  setSearchKey(searchItem: any, module: string) {
    this.searchKeys[module] = searchItem;
  }

  getSearchKey(field: string) {
    return this.searchKeys ? this.searchKeys?.[field] : null;
  }

  setAlertDtcFilters(isActive: boolean, alertDtc: string) {
    this.isActiveAlertDtc[alertDtc] = isActive;
  }

  getAlertDtcFilters(alertDtc : string) {
    return this.isActiveAlertDtc ? this.isActiveAlertDtc?.[alertDtc] : {};
  }

  getInsight(reqData: {
    type: string;
    tripIds: string[];
  }) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.insights,
      reqData,
      true
    );
  }

  /**
   * Gets trip segments
   * @param reqData 
   * @returns  
   */
  getTripSegments(reqData: {entityId?: string, from?: string, to?: string, type?: string, tripId?: string, limit ?: number}) {
    let params = new HttpParams();
    Object.entries(reqData)?.forEach(([key, value]) => {
      if (value != null) {
        params = params.set(key, value);
      }
    });
    return this.httpGuard.httpReq(
      'get',
      'API_ENDPOINT',
      ApiConstants.URL.tripSegments,
      `?${params}` 
    );
  }

  /**
   * Gets trip performace score
   * @param payload 
   * @returns  
   */
  getTripPerformaceScore(payload: {entityId: string, type: string, count: number}) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.tripPerformanceScore,
      payload,
      true
    );
  }

  /**
   * Gets current trip score
   */
   getCurrentTripPosition(reqPayload : {tripId : string, entityId : string}) {
    let params = new HttpParams();
    Object.entries(reqPayload)?.forEach(([key, value]) => {
      if (value != null) {
        params = params.set(key, value);
      }
    });
    return this.httpGuard.httpReq(
      'get',
      'API_ENDPOINT',
      ApiConstants.URL.currentTripPosition,
      `?${params}` 
    );
  }


  /**
   * Gets attribute aggregate
   * @param payload 
   * @returns  
   */
  getAttributeAggregate(payload: {from ?: string, to ?: string, attributeNames : string[], operation : string, entityId: string}) {
    return this.httpGuard.httpReq(
      'post',
      'API_ENDPOINT',
      ApiConstants?.URL?.attributesAggregate,
      payload,
      true
    );
  }

  truncateTo(num: any, decimals: number = 0): string {
    if (isNaN(num) || num === null || num === undefined) return String(num);

    const factor = Math.pow(10, decimals);
    const truncated = Math.trunc(Number(num) * factor) / factor;

    return truncated.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals
    });
  }

  setVehicleDateRange(date : any) {
    this.entitiesDateApplied = date;
  }

  getVehicleDateRange() {
    return this.entitiesDateApplied;
  }

  setDateState(type: string, range: string, date: { startDate: any; endDate: any }) {
    const index = this.dateState?.findIndex(item => item?.type === type);
    const dateState = { type, range, date };
    if (index !== -1) {
      this.dateState[index] = dateState;
    } else {
      this.dateState?.push(dateState);
    }
  }

  clearDateState(type?: string) {
    this.dateState = this.dateState.filter(item => {
      if (type && type !== 'all') {
        return item.type !== type;
      }
      if (type === 'all') {
        return false;   
      }
      return item.type === 'global';
    });
  }

  getDateState(type?: string) {
    return this.dateState?.find(item => type ? (item.type === type) : item);
  }

}
